//Actions

//Import action type:
import {
  GET_SYSTEM_MODULE_LIST,
  GET_SYSTEM_MODULE_LIST_SUCCESS,
  GET_SYSTEM_MODULE_LIST_FAIL,
  GET_SYSTEM_MODULE_DATA,
  GET_SYSTEM_MODULE_DATA_SUCCESS,
  GET_SYSTEM_MODULE_DATA_FAIL,
  ACTIVATE_SYSTEM_MODULE,
  ACTIVATE_SYSTEM_MODULE_SUCCESS,
  ACTIVATE_SYSTEM_MODULE_FAIL,
  DEACTIVATE_SYSTEM_MODULE,
  DEACTIVATE_SYSTEM_MODULE_SUCCESS,
  DEACTIVATE_SYSTEM_MODULE_FAIL,
  CREATE_SYSTEM_MODULE,
  CREATE_SYSTEM_MODULE_SUCCESS,
  CREATE_SYSTEM_MODULE_FAIL,
  UPDATE_SYSTEM_MODULE,
  UPDATE_SYSTEM_MODULE_SUCCESS,
  UPDATE_SYSTEM_MODULE_FAIL,
  DELETE_SYSTEM_MODULE,
  DELETE_SYSTEM_MODULE_SUCCESS,
  DELETE_SYSTEM_MODULE_FAIL,
} from "./actionType";

// List
export const getSystemModuleList = () => ({
  type: GET_SYSTEM_MODULE_LIST,
});

export const getSystemModuleListSuccess = (data) => ({
  type: GET_SYSTEM_MODULE_LIST_SUCCESS,
  payload: data,
});

export const getSystemModuleListFail = (error) => ({
  type: GET_SYSTEM_MODULE_LIST_FAIL,
  payload: error,
});

// Data
export const getSystemModuleData = (id) => ({
  type: GET_SYSTEM_MODULE_DATA,
  payload: id,
});

export const getSystemModuleDataSuccess = (data) => ({
  type: GET_SYSTEM_MODULE_DATA_SUCCESS,
  payload: data,
});

export const getSystemModuleDataFail = (error) => ({
  type: GET_SYSTEM_MODULE_DATA_FAIL,
  payload: error,
});

// Activate
export const activateSystemModule = (data) => ({
  type: ACTIVATE_SYSTEM_MODULE,
  payload: data,
});

export const activateSystemModuleSuccess = (data) => ({
  type: ACTIVATE_SYSTEM_MODULE_SUCCESS,
  payload: data,
});

export const activateSystemModuleFail = (error) => ({
  type: ACTIVATE_SYSTEM_MODULE_FAIL,
  payload: error,
});

// Deactivate
export const deactivateSystemModule = (data) => ({
  type: DEACTIVATE_SYSTEM_MODULE,
  payload: data,
});

export const deactivateSystemModuleSuccess = (data) => ({
  type: DEACTIVATE_SYSTEM_MODULE_SUCCESS,
  payload: data,
});

export const deactivateSystemModuleFail = (error) => ({
  type: DEACTIVATE_SYSTEM_MODULE_FAIL,
  payload: error,
});

// Create
export const createSystemModule = (data) => ({
  type: CREATE_SYSTEM_MODULE,
  payload: data,
});

export const createSystemModuleSuccess = (data) => ({
  type: CREATE_SYSTEM_MODULE_SUCCESS,
  payload: data,
});

export const createSystemModuleFail = (error) => ({
  type: CREATE_SYSTEM_MODULE_FAIL,
  payload: error,
});

// Update
export const updateSystemModule = (data) => ({
  type: UPDATE_SYSTEM_MODULE,
  payload: data,
});

export const updateSystemModuleSuccess = (data) => ({
  type: UPDATE_SYSTEM_MODULE_SUCCESS,
  payload: data,
});

export const updateSystemModuleFail = (error) => ({
  type: UPDATE_SYSTEM_MODULE_FAIL,
  payload: error,
});

// Delete
export const deleteSystemModule = (data) => ({
  type: DELETE_SYSTEM_MODULE,
  payload: data,
});

export const deleteSystemModuleSuccess = (data) => ({
  type: DELETE_SYSTEM_MODULE_SUCCESS,
  payload: data,
});

export const deleteSystemModuleFail = (error) => ({
  type: DELETE_SYSTEM_MODULE_FAIL,
  payload: error,
});
